// EventSource.onerror doesn't expose the HTTP status code, so a permanent
// 403 can't be told apart from a transient network blip here — cap retries
// after repeated consecutive failures instead of retrying forever.
export const MAX_CONSECUTIVE_ERRORS = 5;

// Client-side cap on concurrent SSE streams. The server rejects beyond 5 per
// user with 503; keeping the client cap lower avoids hitting that limit when
// several generations and refinements are in flight simultaneously. Contexts
// over the cap fall back to polling.
export const MAX_CONCURRENT_CONNECTIONS = 3;
